'use client';

import * as React from 'react';

export type DeviceOS = 'ios' | 'android' | null;

function detectOS(): DeviceOS {
  if (typeof navigator === 'undefined') return null;
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
  if (
    typeof navigator.platform === 'string' &&
    navigator.platform === 'MacIntel' &&
    typeof navigator.maxTouchPoints === 'number' &&
    navigator.maxTouchPoints > 1
  ) {
    return 'ios';
  }
  if (/Android/i.test(ua)) return 'android';
  return null;
}

/**
 * Returns the user's mobile OS — `'ios'`, `'android'`, or `null` for anything
 * else (desktop, mobile-Linux, unknown). SSR-safe: returns `null` on the
 * server and on the first client render, then resolves in `useEffect`.
 */
export function useDeviceOS(): DeviceOS {
  const [os, setOS] = React.useState<DeviceOS>(null);

  React.useEffect(() => {
    setOS(detectOS());
  }, []);

  return os;
}
